import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  adminOnly?: boolean; // New prop to specify if the route is for admins only
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ adminOnly = false }) => {
  const { isAuthenticated, isLoading, is_admin } = useAuth(); // Added is_admin
  const location = useLocation();

  if (isLoading) {
    // You can return a loader component here if you have one
    return <div>Loading authentication status...</div>;
  }

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If the route is admin-only and the user is not an admin, redirect to dashboard or a specific unauthorized page
  if (adminOnly && !is_admin) {
    // Redirect to a general page like dashboard, or a specific "Unauthorized Access" page
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  return <Outlet />; // Render the child route element (the protected page)
}; 